// import React from 'react';

//image size should be 1200 × 661
import { rgbdleImg } from "../img/projImgsObj";

const rgbdleProject = {
  title: "RGBdle",
  extLink: "https://www.rgbdle.page/",
  extLinkText: "View Live Project",
  description: "Like Wordle, but with colors.",
  previewImg: rgbdleImg,
  skills: ["React", "JS/ES6", "CSS3", "Figma"],
  optstyles: "dropshadow",
};

export default rgbdleProject;
